import { Outlet, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from './Header';
import BottomNav from './BottomNav';
import './Layout.css';

const Layout = () => {
    const location = useLocation();
    const isMapPage = location.pathname === '/map';

    return (
        <>
            {!isMapPage && <Header />}
            <main
                className={isMapPage ? 'layout-main layout-main--map' : 'layout-main'}
            >
                <motion.div
                    key={location.pathname}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.3 }}
                >
                    <Outlet />
                </motion.div>
            </main>
            <BottomNav />
        </>
    );
};

export default Layout;
